import { css, styled } from '@obvio/app'
import { Section, Video } from '@obvio/ui'

import { FadeIn } from '../FadeIn'

import type { VideoProps } from '@obvio/ui'
import type { ReactElement } from 'react'

type ArtistVideoProps = VideoProps

const outerCss = css`
  width: 100% !important;
  max-width: 100% !important;
`

const MaxWidthSection = styled(Section)`
  width: 100% !important;
  max-width: 100% !important;
`

export function ArtistVideo({ source, id }: ArtistVideoProps): ReactElement {
  return (
    <MaxWidthSection outerCss={outerCss}>
      <FadeIn>
        <Video source={source} id={id} />
      </FadeIn>
    </MaxWidthSection>
  )
}
